import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {useTranslate} from "../../system/useTranslate";
import {useNavigate} from "react-router-dom";
import {useGoal} from "../../models/goal/use-goal";
import {useProject} from "../../models/project/use-project";
import StrategyMap from "../goals/tabs/strategy-map";
import MyGoals from "../goals/tabs/my-goals";
import TeamGoals from "../goals/tabs/team-goals";
import GlobalSettings from "./tabs/global-settings";
import ManageMembers from "./tabs/manage-members";
import {BreadCrumb} from "primereact/breadcrumb";
import Icon from "../../system/components/icon";
import PageHeaderButton from "../components/page-header-button";
import {Button} from "primereact/button";
import {TabPanel, TabView} from "primereact/tabview";
import GoalProjectDialog from "../goals/components/goal-project-dialog";
import GoalSidebar from "../goals/components/goal-sidebar";
import ProjectSidebar from "../projects/components/project-sidebar";
import SelectableTabsButton, {useSelectableTabs} from "../components/selectable-tabs-button";

function Index(props) {

    const [activeIndex,setActiveIndex] = useState(0);
    const [breadCrumb,setBreadCrumbData] = useState([]);
    const {workspaceMembershipData} = useSelector((state) => state.app);
    const [createNodeDialogVisible, setCreateNodeDialogVisible] = useState(false);
    const [selectedGoalData, setSelectedGoalData] = useState();
    const [selectedProjectData, setSelectedProjectData] = useState();
    const [pending, setPending] = useState();
    const translate = useTranslate();
    const navigate = useNavigate();
    const dispatch = useDispatch()

    const tabs = [
        { id: "global-settings", label: "global-settings", icon: "mi mi:globe_uk", view:GlobalSettings },
        { id: "manage-members", label: "manage-members", icon: "mi mi:groups", view:ManageMembers, disabled:false }
    ];
    const {visibleTabs, selectedIds, toggleTab} = useSelectableTabs(tabs, "visible-tabs:workspace", activeIndex, setActiveIndex);

    useEffect(()=>{
        setBreadCrumbData([
            {label:translate("workspace"), command:()=>{navigate("/workspace")}}
        ]);
    },[]);
    return(
        <div className="h-full overflow-hidden flex flex-column">
            <BreadCrumb separatorIcon={<Icon icon="mi mi:chevron_left text-xs"/>} className="bg-transparent border-none text-xs" model={breadCrumb}/>
            <PageHeaderButton title={workspaceMembershipData?.workspace?.name} description={workspaceMembershipData?.workspace?.description} end={<div><Button icon={<Icon icon="mi mi:add" className="text-lg ml-1"/>} className="text-xs p-2 pl-3" onClick={()=>{setCreateNodeDialogVisible(true)}} label={translate("create")}/></div>} />
            {/* تب‌ها */}
            <div className="flex-1 min-h-0 flex flex-column relative">
                <SelectableTabsButton tabs={tabs} selectedIds={selectedIds} onChange={toggleTab} className="absolute z-5" style={{top: ".45rem", left: ".75rem"}}/>
                <TabView lazy activeIndex={activeIndex} onTabChange={(e)=>{setActiveIndex(e.index);
                    setBreadCrumbData(prv=>{
                        const next = Array.isArray(prv) ? [...prv] : [];
                        next[1] = {label:translate(visibleTabs[e.index].label)};
                        return next;
                    });
                }}
                         panelContainerClassName="flex-1  min-h-0 p-0 border-noround"
                         className="h-full flex flex-column">
                    {visibleTabs.map((tab, tabIndex) => {
                        const TabContent = tab.view;
                        return (
                        <TabPanel
                            key={tab.id}
                            header={translate(tab.label)}
                            disabled={tab.disabled}
                            leftIcon={<Icon icon={tab.icon} className="pl-2" />}
                            className="h-full text-xs">
                            {tabIndex === activeIndex && <div className="h-full min-h-0 overflow-hidden">
                                <TabContent setGoalDialogVisible={setCreateNodeDialogVisible} setPending={setPending} />
                            </div>}
                        </TabPanel>
                    )})}
                </TabView>
            </div>
        </div>
    )
}

export default Index;
